import React from 'react';
import { FormControlLabel, Radio, SxProps, Typography, styled } from '@mui/material';

export interface TwRadioButtonProps {
  /**
   * The id of the input element.
   */
  id?: string;
  /**
   * Label text for the checkbox.
   */
  label: string;
  /**
   * Checkbox editable status.
   */
  disabled?: boolean;
  /**
   * Checkbox value
   */
  value: boolean | string;
  /**
   * Name of checkbox
   */
  name: string;
  /**
   * Callback fired when the value is changed.
   */
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * Sets the radio button checked if true and unckecked if false
   */
  checked?: boolean;
  /**
   * Extra classes for the radio button
   */
  classNames?: string;
  /**
   * Material UI SxProps
   */
  sx?: SxProps;
}

const StyledRadioLabel = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '14px',
  fontWeight: 400
});

const TwRadioButton: React.FC<TwRadioButtonProps> = ({
  id,
  label,
  name,
  disabled,
  value,
  checked,
  classNames,
  sx,
  onInputChange
}) => {
  return (
    <FormControlLabel
      className={classNames}
      value={value}
      control={
        <Radio
          className={`tid-radio-button`}
          checked={checked}
          name={name}
          onChange={onInputChange}
          value={value}
          disabled={disabled}
          id={id}
          sx={{
            padding: '0px 5px 0 10px',
            color: '#3959df',
            '&.Mui-checked': {
              color: '#3959df'
            },
            '& .MuiSvgIcon-root': {
              fontSize: 22
            },
            ...sx
          }}
        />
      }
      label={<StyledRadioLabel className="tid-radio-button__label">{label}</StyledRadioLabel>}
    />
  );
};

TwRadioButton.defaultProps = {
  disabled: false
};

export default TwRadioButton;
